import React from "react";
import { Doughnut } from "react-chartjs-2";
import Chart from 'chart.js/auto';

// Ortadaki metni özelleştirmek için plugin kaydet
Chart.register({
  id: 'centerText',
  beforeDraw: function (chart) {
    const width = chart.width;
    const height = chart.height;
    const ctx = chart.ctx;

    ctx.restore();
    ctx.font = "bold 16px Arial";
    ctx.fillStyle = "#000";
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    const textX = width / 2;
    const textY = height / 2;
    ctx.fillText("", textX, textY); // Boş metin
    ctx.save();
  }
});

const CDoughnut = React.memo(
  (props) => {
    const options = {
      cutout: '70%',
      plugins: {
        legend: {
          display: true,
          position: 'bottom'
        },
        tooltip: {
          enabled: true
        }
      }
    };

    return <Doughnut data={props.data} options={options} style={props.style}></Doughnut>;
  },
  (prevProps, nextProps) => {
    return prevProps.data.datasets["0"].data.every(
      (value, index) => value === nextProps.data.datasets["0"].data[index]
    );
  }
);

export default CDoughnut;
